import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin: false,
    token: '',
    userInfo: {},
    TopMenu: [],
    MenuList: []
  },
  mutations: {
    setToken (state, value) {
      state.token = value
      // localStorage
      sessionStorage.setItem('token', value)
      // localStorage.setItem('token', value)
    },
    setIsLogin (state, value) {
      state.isLogin = value
    },
    setUserInfo (state, value) {
      if (value === '') return
      state.userInfo = value
      sessionStorage.setItem('userInfo', JSON.stringify(value))
      // localStorage.setItem('userInfo', JSON.stringify(value))
    },
    setTopMenu (state, value) {
      if (value === '') return
      state.TopMenu = value
      sessionStorage.setItem('TopMenu', JSON.stringify(value))
      // localStorage.setItem('TopMenu', JSON.stringify(value))
    },
    setMenuList (state, value) {
      if (value === '') return
      state.MenuList = value
      sessionStorage.setItem('MenuList', JSON.stringify(value))
      // localStorage.setItem('MenuList', JSON.stringify(value))
    }
  },
  actions: {
  },
  modules: {
  }
})
